export default class K {
  static baseUrl = process.env.REACT_APP_API_ORIGIN

  static update_user_url = `${K.baseUrl}updateuser`
  static rating_url = `${K.baseUrl}v1/restaurantapi/reviews/add`
  static update_rating_url = `${K.baseUrl}v1/restaurantapi/reviews/edit`
  static view_history_url = `${K.baseUrl}users/viewhistory`
  static scheduled_orders_url = `${K.baseUrl}v1/order/scheduled`

  static track_order_url = `${K.baseUrl}users/trackorder`
  static get_driver_url = `${K.baseUrl}users/getdriver`
  static fetchuser_url = `${K.baseUrl}fetchuser`
  static signup_partner_url = `${K.baseUrl}v1/partner`
  static contact_us_url = `${K.baseUrl}v1/contact`
  static riderRegister = `${K.baseUrl}v1/rider`
  static socialFB = `${K.baseUrl}facebook/login`
  static socialGoogle = `${K.baseUrl}google/login`
  static riderLogin = `${K.baseUrl}v1/rider/login`
  static riderUpdateProfile = (userId) =>
    `${K.baseUrl}v1/rider/update/${userId}`
  static google_api_key = 'AIzaSyAlPcCmX-WkEH4FGDZ-gf9tslZ9gVcpecU'

  static imageBaseUlr = K.baseUrl.replace('api/', '')
}
